import { InteractionHandler } from "../Interactions";
import { ForwardInteraction } from "flavr-common";
/**
 * This class handles the interaction with models, that have the ForwardInteraction-Behaviors.
 */
export class ForwardInteractionHandler extends InteractionHandler {
    constructor(interactionModule) {
        super(ForwardInteraction.typestatic, [ForwardInteraction.typestatic], [], []);
        this.interactionModule = interactionModule;
    }
    getBehaviorDescription(params, uid) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            return this.interactionModule.getInteractionDescription(params.uid);
        }
        return "";
    }
    onSelect(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onSelect(params.uid, controller, hitPoint);
        }
    }
    onDeselect(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onDeselect(params.uid, controller, hitPoint);
        }
    }
    onSelectButtonPress(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onSelectButtonPress(params.uid, controller, hitPoint);
        }
    }
    onSelectButtonRelease(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onSelectButtonRelease(params.uid, controller, hitPoint);
        }
    }
    onSelectButtonHold(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onSelectButtonHold(params.uid, controller, hitPoint);
        }
    }
    onSelectButtonHoldReleased(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onSelectButtonHoldReleased(params.uid, controller, hitPoint);
        }
    }
    onSelectButtonClick(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onSelectButtonClick(params.uid, controller, hitPoint);
        }
    }
    onSelectButtonDoubleClick(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            void this.interactionModule.onSelectButtonDoubleClick(params.uid, controller, hitPoint);
        }
    }
    onControllerMove(params, uid, controller, hitPoint) {
        if (ForwardInteraction.is(params) && uid !== params.uid) {
            this.interactionModule.onControllerMove(params.uid, controller, hitPoint);
        }
    }
}
